<template>
  <v-flex xs12 sm10 md6 class="entry__container">
    <div class="app-logo text-xs-center pb-5">
      XProperty
    </div>
    <v-card elevation="2" class="pa-4">
      <v-card-title primary-title class="py-3">
        <h1>Forgot Password</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="email"
            label="Email"
            :rules="emailRules"
            required
          />
        </v-form>
        <p v-if="showMessage" class="red--text">{{ statusText }}</p>
      </v-card-text>
      <v-card-actions class="py-3">
        <v-btn flat router to="/">Login</v-btn>
        <v-btn flat router to="/register">Register</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="primary" @click="forgetPasswordClicked"
          >Reset Password</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import alertHelper from '@/helpers/alert'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\.+/.test(v) || 'E-mail must be valid',
      ],
      valid: false,
      showMessage: false,
      statusText: '',
    }
  },
  methods: {
    ...mapActions({
      forgetPassword: 'User/forgetPasssword',
    }),
    forgetPasswordClicked() {
      if (this.$refs.form.validate()) {
        this.forgetPassword({
          email: this.email,
        })
      } else {
        alertHelper.error('Please enter your email')
      }
    },
  },
}
</script>
